import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Swiper Imports
import Swiper from "swiper";
import { Autoplay, Navigation, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

function Home() {
  const carouselRef = useRef(null);
  const [formStatus, setFormStatus] = useState("");

  // ================================
  // 1. BANNER SWIPER SLIDER INIT
  // ================================
  useEffect(() => {
    try {
      const banner = document.querySelector(".banner-slider");
      if (!banner) return;

      new Swiper(".banner-slider", {
        modules: [Autoplay, Navigation, EffectFade],
        loop: true,
        speed: 900,
        autoplay: { delay: 3000, disableOnInteraction: false },
        effect: "fade",
        fadeEffect: { crossFade: true },
      });
    } catch (err) {
      console.warn("Swiper error", err);
    }
  }, []);

  // ================================
  // 2. INFINITE SMOOTH CAROUSEL
  // ================================
  useEffect(() => {
    const wrap = document.querySelector(".carousel-wrap");
    if (!wrap) return;

    const carousel = wrap.querySelector(".why-carousel");
    if (!carousel) return;

    const btnLeft = wrap.querySelector(".scroll-btn.left");
    const btnRight = wrap.querySelector(".scroll-btn.right");

    const originalItems = Array.from(carousel.children);
    if (originalItems.length === 0) return;

    originalItems.forEach((node) => carousel.appendChild(node.cloneNode(true)));

    let baseSpeed = 1;
    let isPaused = false;
    let holdDir = 0;
    let rafId = null;

    const loop = () => {
      if (!isPaused) {
        const step = holdDir !== 0 ? holdDir * 4.5 : baseSpeed;
        carousel.scrollLeft += step;

        if (carousel.scrollLeft >= carousel.scrollWidth / 2) {
          carousel.scrollLeft -= carousel.scrollWidth / 2;
        } else if (carousel.scrollLeft <= 0) {
          carousel.scrollLeft += carousel.scrollWidth / 2;
        }
      }
      rafId = requestAnimationFrame(loop);
    };

    rafId = requestAnimationFrame(loop);

    const pause = () => (isPaused = true);
    const resume = () => (isPaused = false);

    carousel.addEventListener("mouseenter", pause);
    carousel.addEventListener("mouseleave", resume);
    carousel.addEventListener("touchstart", pause, { passive: true });
    carousel.addEventListener("touchend", resume);

    if (btnLeft) {
      btnLeft.addEventListener("click", () =>
        carousel.scrollBy({ left: -300, behavior: "smooth" })
      );
      btnLeft.addEventListener("mousedown", () => { holdDir = -1; isPaused = false; });
      btnLeft.addEventListener("touchstart", () => { holdDir = -1; isPaused = false; }, { passive: true });
      btnLeft.addEventListener("mouseleave", () => { holdDir = 0; });
    }

    if (btnRight) {
      btnRight.addEventListener("click", () =>
        carousel.scrollBy({ left: 300, behavior: "smooth" })
      );
      btnRight.addEventListener("mousedown", () => { holdDir = 1; isPaused = false; });
      btnRight.addEventListener("touchstart", () => { holdDir = 1; isPaused = false; }, { passive: true });
      btnRight.addEventListener("mouseleave", () => { holdDir = 0; });
    }

    const stopHold = () => { holdDir = 0; };
    window.addEventListener("mouseup", stopHold);
    window.addEventListener("touchend", stopHold);

    return () => {
      carousel.removeEventListener("mouseenter", pause);
      carousel.removeEventListener("mouseleave", resume);
      carousel.removeEventListener("touchstart", pause);
      carousel.removeEventListener("touchend", resume);
      window.removeEventListener("mouseup", stopHold);
      window.removeEventListener("touchend", stopHold);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div className="info-back-drop"></div>

      {/* BANNER SECTION */}
      <section className="banner-section">
        <div className="banner-social-list">
          <span className="line"></span>
          <ul className="custom-ul">
            <li><a href="https://www.facebook.com/share/16rD3zZNRy/">FB</a></li>
            <li><a href="https://www.instagram.com/tickling.tummy?igsh=dmlwM29pNjc4a3Fw">IN</a></li>
          </ul>
          <span className="line"></span>
        </div>

        <div className="banner-call">
          <span className="line"></span>
          <ul className="call-ul">
            <li><a href="tel:+919385000111">Booking : +91-9385000111</a></li>
          </ul>
          <span className="line"></span>
        </div>

        <div className="banner-container">
          <div className="auto-container">
            <div className="content-box banner-text-top">
              <div className="content">
                <div className="clearfix">
                  <div className="inner">
                    <h1>One Dabba is - Never Enough</h1>
                  </div>
                </div>
              </div>
            </div>

            {/* WORKING SWIPER BANNER */}
            <div className="banner-slider slider-contained">
              <div className="swiper-wrapper">
                <div className="swiper-slide slide-item">
                  <div className="image-layer" style={{ backgroundImage: "url(assets/images/main-slider/home-style-veg-meals-slider.webp)" }}></div>
                </div>
                <div className="swiper-slide slide-item">
                  <div className="image-layer" style={{ backgroundImage: "url(assets/images/main-slider/healthy-tiffin-service-slider.webp)" }}></div>
                </div>
                <div className="swiper-slide slide-item">
                  <div className="image-layer" style={{ backgroundImage: "url(assets/images/main-slider/traditional-south-indian-food-slider.webp)" }}></div>
                </div>
              </div>
              <div className="swiper-button-prev"><span className="fal fa-angle-left"></span></div>
              <div className="swiper-button-next"><span className="fal fa-angle-right"></span></div>
            </div>
          </div>
        </div>

        <a href="https://api.whatsapp.com/send/?phone=919385000111&text&type=phone_number&app_absent=0" className="book-btn">
          <span className="icon">
            <img src="assets/images/resource/book-food-online-icon.png" alt="home cooked food delivery Coimbatore" />
          </span>
        </a>
      </section>

      {/* About Section */}
      <section className="about-section section-kt">
        <div className="container-fluid">
          <div className="title-box centered">
            <div className="subtitle"><span>About Us</span></div>
            <h2>Homemade Food <span className="theme_color">from<br />Our Kitchen </span> to You</h2>
          </div>
          <div className="row clearfix">
            <div className="text-col col-xl-6 col-lg-4 col-md-8 mx-auto">
              <div className="inner wow fadeInLeft">
                <p style={{ fontSize: "1.2rem", color: "var(--white-color)", fontStyle: "italic", lineHeight: "1.6em" }}>
                  <strong>Tickling Tummy</strong> is a premier <strong>homemade vegetarian food service in Coimbatore</strong>, located in <strong>R.S. Puram</strong>. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering, serving the local community with fresh, hygienic, and authentic home-cooked meals.
                </p>
                <div className="lower-link-box text-center">
                  <a href="about" className="theme-btn btn-style-two clearfix">
                    <span className="btn-wrap">
                      <span className="text-one">About us</span>
                      <span className="text-two">About us</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="image-col col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="inner wow fadeInRight">
              <div className="floating-images">
                <div className="abt-image1 parallax-scene-1">
                  <img data-depth="0.50" src="assets/images/resource/about-tickling-tummy-kitchen-1.jpg" alt="vegetarian food delivery Coimbatore" loading="lazy" />
                </div>
                <div className="abt-image2 parallax-scene-2">
                  <img data-depth="0.50" src="assets/images/tickling-tummy-kitchen-overview.jpg" alt="homemade lunch delivery Coimbatore" loading="lazy" />
                </div>
                <div className="abt-image3 parallax-scene-3">
                  <img data-depth="0.90" src="assets/images/resource/about-tickling-tummy-kitchen-3.jpg" alt="daily meal delivery Coimbatore" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Us / Services Carousel */}
      <section className="why-us-two section-kt">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Services</span></div>
            <h2>What We Offer</h2>
          </div>

          <div className="carousel-wrap">
            <button className="scroll-btn left" aria-label="Scroll left">⇚</button>
            <button className="scroll-btn right" aria-label="Scroll right">⇛</button>

            <div className="why-carousel" ref={carouselRef}>
              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/daily-veg-meal-subscription-coimbatore.jpg" alt="home food service Coimbatore" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="daily-meals">
                      <h6>Daily Meals</h6>
                    </a>
                    <p>Pure veg homemade meals for pickup. Freshly made with rotating menus.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/custom-pre-order-meals-coimbatore.jpg" alt="homemade tiffin service Coimbatore" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="pre-order-meals">
                      <h6>Pre-order Meals</h6>
                    </a>
                    <p>Less oil, low salt, no ghee, air-fried? Customize your order easily.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/monthly-meal-subscription-service-coimbatore.jpg" alt="Coimbatore homemade lunch box" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="meal-subscription">
                      <h6>Meal Subscription</h6>
                    </a>
                    <p>Weekly/monthly plans for lunch, dinner, or all three. Pickup or delivery available.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/corporate-catering-food-service-coimbatore.jpg" alt="Coimbatore veg meal delivery" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="corporate">
                      <h6>Corporate & Institutional Catering</h6>
                    </a>
                    <p>Serving teams, schools, and travel groups with healthy, home-style food.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/train-food-delivery-coimbatore.jpg" alt="South Indian veg meal delivery" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="food-delivery-in-train">
                      <h6>Food Delivery on Train (CBE)</h6>
                    </a>
                    <p>Packed and ready for groups while travelling.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/festive-food-gifting-hampers-coimbatore.jpg" alt="Coimbatore vegetarian lunch box" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="gifting">
                      <h6>Festive Gifting</h6>
                    </a>
                    <p>Homemade sweet, bake, and savory hampers for festivals and milestones.</p>
                  </div>
                </div>
              </div>

              <div className="why-block-two">
                <div className="inner-box">
                  <div className="image-box">
                    <img src="assets/images/event-catering-service-coimbatore.jpg" alt="pure veg food delivery Coimbatore" loading="lazy" />
                  </div>
                  <div className="over-box">
                    <a href="catering">
                      <h6>Event Catering</h6>
                    </a>
                    <p>Custom menus and flexible portions for events and parties.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Reserve / Pre-Order Form */}
      <section className="reserve-section style-two section-kt">
        <div className="image-layer" style={{ backgroundImage: "url(assets/images/background/herbs-and-spices-reservation-background.jpg)" }}></div>
        <div className="auto-container">
          <div className="outer-box">
            <div className="row clearfix">
              <div className="reserv-col col-lg-8 col-md-12 col-sm-12 mx-auto">
                <div className="inner">
                  <div className="title-box centered">
                    <div className="subtitle"><span>For Order</span></div>
                    <h2>Pre Order Now</h2>
                    <div className="request-info">
                      Booking request <a href="tel:+919385000111">+91 9385000111</a> or fill out the order form
                    </div>
                  </div>

                  <div className="default-form reservation-form">
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const formData = new FormData(e.target);
                        const formBody = new URLSearchParams(formData).toString();
                        setFormStatus('Sending...');

                        try {
                          const res = await fetch('save_reservation.php', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/x-www-form-urlencoded',
                              'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: formBody
                          });

                          const data = await res.json();
                          if (data.success) {
                            setFormStatus('✅ ' + data.message);
                            e.target.reset();
                          } else {
                            setFormStatus('❌ ' + data.message);
                          }
                        } catch (err) {
                          console.error(err);
                          setFormStatus('❌ Error sending request.');
                        }
                      }}
                    >
                      <input
                        type="text"
                        name="website"
                        autoComplete="off"
                        tabIndex="-1"
                        aria-hidden="true"
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                      />
                      <div className="row clearfix">
                        <div className="form-group col-lg-6">
                          <div className="field-inner">
                            <input type="text" name="name" placeholder="Your Name" required />
                          </div>
                        </div>
                        <div className="form-group col-lg-6">
                          <div className="field-inner">
                            <input type="text" name="phone" placeholder="Phone Number" required />
                          </div>
                        </div>

                        <div className="form-group col-lg-4">
                          <div className="field-inner">
                            <span className="alt-icon far fa-user"></span>
                            <select name="persons" className="l-icon">
                              {[1, 2, 3, 4, 5, 6, 7].map(n => (
                                <option key={n}>{n} Person{n > 1 ? 's' : ''}</option>
                              ))}
                            </select>
                            <span className="arrow-icon far fa-angle-down"></span>
                          </div>
                        </div>

                        <div className="form-group col-lg-4">
                          <div className="field-inner">
                            <span className="alt-icon far fa-calendar"></span>
                            <input type="date" name="date" className="l-icon datepicker" required />
                            <span className="arrow-icon far fa-angle-down"></span>
                          </div>
                        </div>

                        <div className="form-group col-lg-4">
                          <div className="field-inner">
                            <span className="alt-icon far fa-clock"></span>
                            <select name="time" className="l-icon">
                              {[
                                "08:00 am", "09:00 am", "10:00 am", "11:00 am",
                                "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm",
                                "04:00 pm", "05:00 pm", "06:00 pm", "07:00 pm",
                                "08:00 pm", "09:00 pm", "10:00 pm"
                              ].map((t, i) => (
                                <option key={i}>{t}</option>
                              ))}
                            </select>
                            <span className="arrow-icon far fa-angle-down"></span>
                          </div>
                        </div>

                        <div className="form-group col-lg-12">
                          <div className="field-inner">
                            <textarea name="message" placeholder="Message" required></textarea>
                          </div>
                        </div>

                        <div className="form-group col-lg-12">
                          <div className="field-inner">
                            <button type="submit" className="theme-btn btn-style-one clearfix">
                              <span className="btn-wrap">
                                <span className="text-one">Order Now</span>
                                <span className="text-two">Order Now</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    {formStatus && <p style={{ color: "var(--white-color)", marginTop: "10px", fontWeight: "bold" }}>{formStatus}</p>}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* FAQ Section */}
      <section className="faq-section section-kt" style={{ paddingBottom: "80px" }}>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>FAQs</span></div>
            <h2>Got Questions? <span className="theme_color">We’ve Got Answers</span></h2>
          </div>

          <div className="row clearfix">
            <div className="col-lg-10 col-md-12 col-sm-12 mx-auto">
              <div className="faq-content">
                <div className="faq-item" style={{ marginBottom: "30px", padding: "20px", background: "#ffffff", borderRadius: "8px", borderLeft: "4px solid #8a101a", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
                  <h4 style={{ color: "#8a101a", marginBottom: "10px", fontWeight: "600" }}>Where can I get pure veg homemade food delivery in Coimbatore?</h4>
                  <p style={{ color: "#333333", lineHeight: "1.6" }}>Tickling Tummy represents the finest homemade vegetarian food service in Coimbatore, specializing in fresh, hygienic meals delivered with love. Our kitchen is located in R.S. Puram, and we serve customers across the city.</p>
                </div>
                <div className="faq-item" style={{ marginBottom: "30px", padding: "20px", background: "#ffffff", borderRadius: "8px", borderLeft: "4px solid #8a101a", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
                  <h4 style={{ color: "#8a101a", marginBottom: "10px", fontWeight: "600" }}>Do you offer healthy tiffin services for office goers in Coimbatore?</h4>
                  <p style={{ color: "#333333", lineHeight: "1.6" }}>Yes! Our healthy tiffin service is perfect for professionals. We use minimal oil, fresh ingredients, and offer rotating menus so you never get bored. You can subscribe to our daily lunch or dinner plans.</p>
                </div>
                <div className="faq-item" style={{ marginBottom: "30px", padding: "20px", background: "#ffffff", borderRadius: "8px", borderLeft: "4px solid #8a101a", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
                  <h4 style={{ color: "#8a101a", marginBottom: "10px", fontWeight: "600" }}>How do I subscribe to daily homemade meals in RS Puram?</h4>
                  <p style={{ color: "#333333", lineHeight: "1.6" }}>Subscribing is easy! You can choose from our weekly or monthly meal plans via our website or by calling us at +91 9385000111. We offer both pickup and delivery options within RS Puram and nearby areas.</p>
                </div>
                <div className="faq-item" style={{ marginBottom: "30px", padding: "20px", background: "#ffffff", borderRadius: "8px", borderLeft: "4px solid #8a101a", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
                  <h4 style={{ color: "#8a101a", marginBottom: "10px", fontWeight: "600" }}>Do you provide catering for small house parties in Coimbatore?</h4>
                  <p style={{ color: "#333333", lineHeight: "1.6" }}>Absolutely. We specialize in "gourmet-style" small event catering. Whether it's a birthday, anniversary, or a small family gathering, we provide customized pure veg menus tailored to your preferences.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Where can I get pure veg homemade food delivery in Coimbatore?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Tickling Tummy represents the finest homemade vegetarian food service in Coimbatore, specializing in fresh, hygienic meals delivered with love. Our kitchen is located in R.S. Puram, and we serve customers across the city."
                }
              },
              {
                "@type": "Question",
                "name": "Do you offer healthy tiffin services for office goers in Coimbatore?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes! Our healthy tiffin service is perfect for professionals. We use minimal oil, fresh ingredients, and offer rotating menus so you never get bored. You can subscribe to our daily lunch or dinner plans."
                }
              },
              {
                "@type": "Question",
                "name": "How do I subscribe to daily homemade meals in RS Puram?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Subscribing is easy! You can choose from our weekly or monthly meal plans via our website or by calling us at +91 9385000111. We offer both pickup and delivery options within RS Puram and nearby areas."
                }
              },
              {
                "@type": "Question",
                "name": "Do you provide catering for small house parties in Coimbatore?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Absolutely. We specialize in \"gourmet-style\" small event catering. Whether it's a birthday, anniversary, or a small family gathering, we provide customized pure veg menus tailored to your preferences."
                }
              }
            ]
          })}
        </script>
      </section>
    </>
  );
}

export default Home;
